import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './VisaRate.css';

const VisaRateCalculator = () => {
  const [country, setCountry] = useState('Dubai');
  const [visaType, setVisaType] = useState('Tourist Visa');
  const [processingSpeed, setProcessingSpeed] = useState('Standard');
  const [nationality, setNationality] = useState('Indian');
  const [duration, setDuration] = useState('12 Days');
  const [calculationResult, setCalculationResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleCalculatePrice = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 10000));
    try {
      const response = await fetch('/api/visa-rate-calculator', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country, visaType, nationality }),
      });

      if (!response.ok) {
        throw new Error('Backend request failed');
      }

      const data = await response.json();
      setCalculationResult(data);
    } catch (err) {
      setCalculationResult({
        serviceFee: 0,
        processingFee1: 0,
        processingFee2: 0,
        taxes: 0,
        totalVisaRate: 0
      });
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApplyNow = () => {
    navigate("/VisaInfo");
  };

  const loadingSkeleton = (width = '100%', height = '20px') => (
    <div
      style={{
        backgroundColor: "#777777",
        borderRadius: "30px",
        width,
        height,
        marginBottom: "10px"
      }}
    ></div>
  );

  return (
    <div>
      <div className="sectiontitle">Visa Rate <span>Calculator</span></div>
      <div className="visa-rate-calculator">
        <div className="calculator-form">
          <div className="rateformrow">
            <div className="form-group">
              {loading ? loadingSkeleton('100px', '20px') : <label>Select Country</label>}
              {loading ? loadingSkeleton() : (
                <select value={country} onChange={(e) => setCountry(e.target.value)}>
                  <option>Dubai</option>
                  <option>UAE</option>
                  <option>Qatar</option>
                </select>
              )}
            </div>
            <div className="form-group">
              {loading ? loadingSkeleton('100px', '20px') : <label>Visa Type</label>}
              {loading ? loadingSkeleton() : (
                <select value={visaType} onChange={(e) => setVisaType(e.target.value)}>
                  <option>Tourist Visa</option>
                  <option>Business Visa</option>
                  <option>Student Visa</option>
                </select>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <div className="form-group">
              {loading ? loadingSkeleton('100px', '20px') : <label>Nationality</label>}
              {loading ? loadingSkeleton() : (
                <select value={nationality} onChange={(e) => setNationality(e.target.value)}>
                  <option>Indian</option>
                  <option>Other</option>
                </select>
              )}
            </div>
          </div>
        </div>

        <div className="calculation-result">
          <div className="fee-breakdown">
            <div className="fee-item">
              <span>
                {loading ? loadingSkeleton('100px') : 'Service fee'}
              </span>
              <span>
                {loading ? loadingSkeleton('100px') : calculationResult ? `₹${calculationResult.serviceFee}` : ""}
              </span>
            </div>
            <div className="fee-item">
              <span>
                {loading ? loadingSkeleton('100px') : 'Processing fee'}
              </span>
              <span>
                {loading ? loadingSkeleton('100px') : calculationResult ? `₹${calculationResult.processingFee1}` : ""}
              </span>
            </div>
            <div className="fee-item">
              <span>
                {loading ? loadingSkeleton('100px') : 'Taxes'}
              </span>
              <span>
                {loading ? loadingSkeleton('100px') : calculationResult ? `₹${calculationResult.taxes}` : ""}
              </span>
            </div>
            <div className="fee-item total">
              <span>
                {loading ? loadingSkeleton('120px') : 'Total Visa Rate:'}
              </span>
              <span>
                {loading ? loadingSkeleton('100px') : calculationResult ? `₹${calculationResult.totalVisaRate}` : ""}
              </span>
            </div>
          </div>

          <div className="action-buttons">
            <button 
              className="calculate-btn" 
              onClick={handleCalculatePrice}
            >
              {loading ? "Calculating..." : "Calculate Price"}
            </button>
            {calculationResult && !loading && (
              <button 
                className="apply-btn" 
                onClick={handleApplyNow}
              >
                Apply Now
              </button>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default VisaRateCalculator;
